// export const isUpcomingHold = clubMembership => {
//   let today = new Date();
//   today = today.toISOString();
//   const results = {
//     isUpcomingHold: false,
//     holdStartDate: null,
//     holdId: null
//   };
//   if (clubMembership.onHolds.length === 0) {
//     return results;
//   }
//   clubMembership.onHolds.forEach(onHold => {
//     if (
//       onHold.startDate > today &&
//       (!onHold.holdStartDate || onHold.startDate < results.holdStartDate)
//     ) {
//       results.isUpcomingHold = true;
//       results.holdStartDate = onHold.startDate;
//       results.holdId = onHold.id;
//     }
//   });
//   return results;
// };

export const isUpcomingCancel = (clubMembership) => {
  let today = new Date();
  today = today.toISOString();
  if (!clubMembership.cancelDate || clubMembership.cancelDate < today) {
    return false;
  }
  return true;
};

export const isUpcomingHold = (clubMembership) => {
  let today = new Date();
  today = today.toISOString();
  if (clubMembership.onHolds.length === 0) {
    return false;
  }
  let isFuture = false;
  clubMembership.onHolds.forEach((onHold) => {
    if (onHold.startDate > today) {
      isFuture = true;
    }
  });
  return isFuture;
};

export const nextHold = (clubMembership) => {
  let today = new Date();
  today = today.toISOString();
  const results = {
    isUpcomingHold: false,
    holdStartDate: null,
    holdId: null
  };
  if (clubMembership.onHolds.length === 0) {
    return null;
  }
  clubMembership.onHolds.forEach((onHold) => {
    if (
      onHold.startDate > today &&
      (!results.holdStartDate || onHold.startDate < results.holdStartDate)
    ) {
      results.isUpcomingHold = true;
      results.holdStartDate = onHold.startDate;
      results.holdId = onHold.id;
    }
  });
  if (!results.isUpcomingHold) {
    return null;
  }
  return results;
};
